import { routes } from "@/consts";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const PaymentMethods: React.FC = () => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  return (
    <div>
      <div className="mt-28">
        <div className="xl:w-[90%] w-[95%] mx-auto grid gap-y-10 md:grid-cols-2 items-center md:justify-items-end">
          <div>
            <h2 className="text-3xl md:text-3xl lg:text-3xl font-bold mb-6 text-gray-800">
              {t("payLater.title")}
            </h2>
            <div className="text-xl md:text-3xl text-gray-600 w-96 md:w-[350px] lg:w-[450px] 2xl:w-[550px]">
              {t("payLater.content")}.
            </div>
          </div>
          <Link
            to={routes.payLater}
            style={{ margin: "auto" }}
            className="bg-black font-bold max-w-72 text-center hover:opacity-90 lg:mr-0 lg:ml-auto mx-auto mb-8 lg:mb-0 text-white rounded-full px-6 py-3 w-[60%]"
          >
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              {t("actions.fillNow")}
            </motion.div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
